import { LinkTabs } from '@meteor/ui';
import { Heading, Theme } from '@radix-ui/themes';
import { Outlet, useLocation } from 'react-router-dom';

export let Layout = () => {
  let { pathname } = useLocation();

  return (
    <Theme>
      <div
        style={{
          width: 1000,
          maxWidth: 'calc(100vw - 40px)',
          margin: '0 auto',
          padding: '100px 20px 20px 20px'
        }}
      >
        <Heading as="h1" size="8" style={{ marginBottom: 10 }}>
          Metorial Admin
        </Heading>

        {/* <TabNav.Root style={{ marginBottom: 20 }}>
          {paths.map(path => (
            <TabNav.Link
              key={path.path}
              href={path.path}
              active={pathname == path.path || pathname.startsWith(`${path.path}/`)}
            >
              {path.name}
            </TabNav.Link>
          ))}
        </TabNav.Root> */}

        <LinkTabs
          current={pathname}
          links={[
            { label: 'Users', to: '/users' },
            { label: 'Agents', to: '/agents' },
            { label: 'Organizations', to: '/organizations' },
            { label: 'Admins', to: '/admins' },
            { label: 'Invites', to: '/invites' },
            { label: 'Auth Config', to: '/auth-config' },
            { label: 'Early Access', to: '/early-access' }
          ]}
        />

        <Outlet />
      </div>
    </Theme>
  );
};
